import { render, staticRenderFns } from "./KunMingNavigation.vue?vue&type=template&id=aa966c22&scoped=true&"
import script from "./KunMingNavigation.vue?vue&type=script&lang=ts&"
export * from "./KunMingNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa966c22",
  null
  
)

export default component.exports